export enum SortOrderType {
    ASC = 'asc',
    DESC = 'desc'
}
